import relativeTime from 'dayjs/plugin/relativeTime.js';

import type { FunctionComponent } from 'react';

import { DAY_MS } from '@dr.pogodin/js-utils';
import { time } from '@dr.pogodin/react-utils';

import { Pill, UserLink, UserRoles } from 'components/admin';

import { P_ADMIN_USERS, type UserT } from 'utils';

import './style.scss';

time.extend(relativeTime);

type PropsT = {
  user: UserT;
};

export const Item: FunctionComponent<PropsT> = ({ user }) => {
  const now = time();

  const created = time(user.createdAt);
  let displayCreatedDay: string;
  if (created.isAfter(now.startOf('day'))) displayCreatedDay = 'Today';
  else if (created.isAfter(now.subtract(1, 'day').startOf('day'))) {
    displayCreatedDay = 'Yesterday';
  } else displayCreatedDay = created.format('MMM DD');

  return (
    <tr>
      <td>
        <div styleName="row">
          <UserLink
            to={`${P_ADMIN_USERS}/${user.id}`}
            user={user}
          />
          {now.valueOf() - user.createdAt < 7 * DAY_MS
            ? <Pill kind="red">New</Pill>
            : null}
        </div>
        <div styleName="userRoles"><UserRoles roles={user.roles} /></div>
      </td>
      {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
      <td>
        <div styleName="column">
          <div styleName="label">{displayCreatedDay}</div>
          <div styleName="lightLabel">{created.format('h:mm A')}</div>
        </div>
      </td>
      <td styleName="label">
        {user.lastSeen ? time(user.lastSeen).fromNow() : 'N/A'}
      </td>
    </tr>
  );
};
